import { sleep } from '../utils'

export const gallery = {
  index: 0,
  delay: 500,
  medias: [
      [
          'IMG-20211009-WA0015.jpg',
          'IMG-20211010-WA0030.jpg',
          'IMG-20211010-WA0031.jpg',
          'IMG-20211010-WA0033.jpg',
          'IMG-20211010-WA0034.jpg',
          'IMG-20211012-WA0020.jpg',
          'IMG-20211012-WA0024.jpg',
          'IMG-20211013-WA0007.jpg',
          'IMG-20211013-WA0041.jpg',
          'IMG-20211014-WA0042.jpg',
          'IMG-20211014-WA0043.jpg',
          'IMG-20211014-WA0044.jpg',
          'IMG-20211014-WA0045.jpg',
          'IMG-20211014-WA0046.jpg',
          'IMG-20211014-WA0047.jpg',
          'IMG-20211016-WA0007.jpg'
      ],
      [
          'IMG-20211016-WA0022.jpg',
          'IMG-20211016-WA0024.jpg',
          'IMG-20211016-WA0029.jpg',
          'IMG-20211017-WA0017.jpg',
          'IMG-20211017-WA0022.jpg',
          'IMG-20211018-WA0000.jpg',
          'IMG-20211018-WA0019.jpg',
          'IMG-20211018-WA0021.jpg',
          'IMG-20211018-WA0024.jpg',
          'IMG-20211018-WA0026.jpg',
          'IMG-20211018-WA0031.jpg',
          'IMG-20211019-WA0033.jpg',
          'IMG-20211019-WA0034.jpg',
          'IMG-20211020-WA0017.jpg',
          'IMG-20211020-WA0018.jpg',
          'IMG-20211021-WA0026.jpg',
          'IMG-20211021-WA0047.jpg',
          'IMG-20211021-WA0048.jpg',
          'IMG-20211022-WA0028.jpg',
          'IMG-20211022-WA0029.jpg'
      ],
      [
          'IMG-20211022-WA0030.jpg',
          'IMG-20211024-WA0008.jpg',
          'IMG-20211025-WA0002.jpg',
          'IMG-20211025-WA0003.jpg',
          'IMG-20211025-WA0004.jpg',
          'IMG-20211025-WA0014.jpg',
          'IMG-20211025-WA0015.jpg',
          'IMG-20211026-WA0011.jpg',
          'IMG-20211027-WA0017.jpg',
          'IMG-20211027-WA0018.jpg',
          'IMG-20211027-WA0020.jpg',
          'IMG-20211029-WA0001.jpg'
      ]
  ].map(wandering => wandering.map(uri => {
    return {
      filename: 'content/gallery/' + uri,
      type: 'image'
    }
  })),
  jugglersNames: [
      'Paul Cretin e Pietro Selva Bonino',
      'Valentina Santori e Thomas Dequidt',
      'Johan Swartvagher e Sylvain Pascal'
  ],
  guestsNames: [
      ['Francisco Martinhano', 'Elisabete Rodrigues', 'Nicolau Da Costa', 'João Mariano'],
      ['Thorsten Grutjen', 'Carlos Santos', 'São Teotónio', 'Thomas Ortegat-Traen'],
      ['Carlos Gomes', 'Don Quichotte e Sancho Pança']
  ],
  guestsInfos: [
      ['Filho de la serra', 'Jornalista', 'Apicultor', 'Fotógrafo'],
      ['Clown malabaristo', 'Artista plástico', 'E seus habitantes', 'Videasta'],
      ['Produtor de eventos e arquitecto', 'Os duplos esquizofrénicos']
  ],

  init () {
      this.displayWandering()
  },

  fadeIn (item) {
    return new Promise(resolve => {
      const anim = item.animate([
        { opacity: 1 },
        { opacity: 0 },
      ], { duration: 500 })
      anim.onfinish = resolve
    })
  },

  fadeOut (item) {
    return new Promise(resolve => {
      const anim = item.animate([
        { opacity: 0 },
        { opacity: 1 },
      ], { duration: 500 })
      anim.onfinish = resolve
    })
  },

  display: {
    image (src, delay) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve([img, sleep(delay)])
        img.onerror = reject
        img.src = src
      })
    },

    video (src) {
      return new Promise((resolve, reject) => {
        const video = document.createElement('video')
        const promise = new Promise(resolve => {
          video.addEventListener('ended', () => resolve())
        })
        video.addEventListener('canplaythrough', () => {
          video.play().then(() => {
            resolve([video, promise])
          }).catch(reject)
        })
        video.addEventListener('error', reject)
        video.muted = true
        video.autoplay = true
        video.src = src
      })
    },
  },

  async displayWandering () {
      if (!this.medias[this.index]) {
        this.index = 0
      }

      const jugglerGif = document.querySelector('#juggling video')
      const jugglerName = document.querySelector('#juggling p')

      jugglerGif.src = '/content/avatars/jugglers/0' + (this.index + 1)  + '.mp4'
      jugglerName.textContent = this.jugglersNames[this.index]

      const medias = this.medias[this.index]
      const galleryDelay = medias.length * this.delay
      const guestDelay = galleryDelay / this.guestsNames[this.index].length

      await Promise.all([
        this.displayGuests(guestDelay, this.index),
        this.displayGallery(this.delay, this.index)
      ])

      this.index++
      this.displayWandering()
  },

  displayGuests (delay, index) {
    return new Promise(async resolve => {
      const names = this.guestsNames[index]
      const infos = this.guestsInfos[index]
      const guestGif = document.querySelector('#guest video')
      const guestImg = document.querySelector('#guest img')
      const guestName = document.querySelector('#guest p:first-of-type')
      const guestInfo = document.querySelector('#guest p:last-of-type')

      for (var i = 0; i < names.length; i++) {
          const i2 = i + 1
          if (index === 1 && i === 2) {
              guestGif.setAttribute('hidden', true)
              guestImg.src = `/content/avatars/guests/${index + 1}/${i2 < 10 ? '0' + i2 : '' + i2}.jpg`
              guestImg.removeAttribute('hidden')
          } else {
              if (guestGif.getAttribute('hidden')) {
                guestImg.setAttribute('hidden', true)
                guestGif.removeAttribute('hidden')
              }
              guestGif.src = `/content/avatars/guests/${index + 1}/${i2 < 10 ? '0' + i2 : '' + i2}.mp4`
          }
          guestName.textContent = names[i]
          guestInfo.textContent = infos[i]
          await sleep(delay)
      }
      resolve()
    })
  },

  displayGallery (delay, index) {
      return new Promise(async resolve => {
          const container = document.querySelector('#week-imgs-component')
          const medias = this.medias[index]

          for (var i = 0; i < medias.length; i++) {
              const currentItem = container.querySelector('figure :first-child')
              try {
                const [newItem, promise] = await this.display[medias[i].type](medias[i].filename, delay)
                currentItem.replaceWith(newItem)
                newItem.classList.add('clickable')
                await promise
              } catch (e) {
                await sleep(delay)
              }
          }
          resolve()
      })
  }
}
